<template>
  <div class="w100m">
    <div id="download" v-if="active == 1">
      <div class="w100m header">
        <div class="div1">
          <img src="./image/logo.png" style="width: 128px" alt="" />
          <p>欢迎来到草都云</p>
        </div>
        <div class="div2">
          <img src="./image/shouji.png" style="width: 272px" alt="" />
          <div class="div3">
            <p>买卖好草好牛 上草都云</p>
            <p>草牧业数智化供应链服务平台</p>
            <div class="div4">
              <div class="div5">
                <div>
                  <img src="./image/app.png" alt="" />
                </div>
                <p>安卓/苹果下载</p>
              </div>
              <div class="div5">
                <div>
                  <img src="./image/mp.png" alt="" />
                </div>
                <p>小程序</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w100m main">
        <div class="main1">
          <div class="main1-div">
            <p class="title">草都云</p>
            <p class="active">草牧业数智化供应链服务平台</p>
            <p>
              通过建设草都云平台，实现生产数字化、管理数字化、质检数字化、能耗数字化、物流数字化、交易数字化;
            </p>
            <p>
              构建数字供应链，打造交易平台、仓储平台和数智园区，实现智慧养殖、智慧仓储、智能生产、线上交易和金融服务为一体的SaaS服务生态圈。
            </p>
            <p>
              草都云平台秉承<span class="active"
                >“让中国的草牧业更加健康、安全和便利”的精神，以“产业+互联网+智慧园区”为核心路径，致力于打造中国最大的草牧业产业供应链绿色生态服务平台。</span
              >
            </p>
            <p>
              截止2024年草都云平台已在9个园区上线运营，在线订单超3万单，累计交易金额25亿，平台注册人数超3000人。
            </p>
          </div>
          <div class="main2-div">
            <div class="content">
              <div v-for="(item, index) in list" :key="index">
                <img src="./image/dui.png" style="width: 32px" alt="" />
                <p>{{ item.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div>
          <p>关于我们</p>
          <span></span>
          <p>联系我们</p>
          <span></span>
          <p>用户协议</p>
        </div>
        <p>
          客服热线: 400 671
          9688&nbsp;&nbsp;&nbsp;&nbsp;联系地址：内蒙古自治区呼和浩特市和林格尔县（草都和林格尔县国家级草牧业园区北84米）
        </p>
        <p>
          Copyright © 2024 内蒙古草都草牧业股份有限公司
          <a
            style="color: white;"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="about_blank"
            >蒙ICP备2020003687号</a
          >
        </p>
      </div>
    </div>
    <div id="download2" v-if="active == 2">
      <div class="w100m headimg">
        <img src="./image/toutu.png" class="w100m" alt="" />
        <div class="div1"></div>
      </div>
      <div class="content">
        <img src="./image/logo2.png" style="width: 78px" alt="" />
        <p class="title1">草都云</p>
        <p class="title2">草牧业数智化供应链服务平台</p>
        <div class="div2">
          <p>
            草都云专注草地、草、牛马羊数字化建设，以大数据和物联网为手段，打造成智能、共享、生态循环的草牧业供应链服务平台。
          </p>
          <p>
            利用互联网技术和创新服务让肉牛行业上游卖得更快、下游买得更好、经纪人市场更大、政府监管更科学高效。
          </p>
          <p class="width">
            为用户提供<span class="active"
              >在线交易、过渡寄养、供应链金融、养殖及运输保险、免疫防疫、贴心售后</span
            >
          </p>
          <p class="width">
            截止2021年，草都云现已运营3个草牧业园区，在建3个园区，累计年成交牛马羊超过<span
              class="active"
              >100万+</span
            >头、年成交草<span class="active">50万+</span>吨。
          </p>
          <img src="./image/yangji.png" alt="" />
        </div>
        <div class="div3">
          <div class="conts">
            <div v-for="(item, index) in list" :key="index">
              <img src="./image/dui.png" alt="" />
              <p>{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="btn" v-if="userAgent == 'andriod'" @click="navigateHref">
          <div>
            <img src="./image/anzhuo.png" alt="" />
            <p>
              <a style="color: white" :href="androidUrl">Android下载</a>
            </p>
          </div>
        </div>
        <div class="btn" v-if="userAgent == 'ios'" @click="navigateHref">
          <div>
            <img src="./image/ios.png" alt="" />
            <p><a style="color: white" :href="iosUrl">iPhone下载</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { name: '一键快捷交易结算' },
        { name: '100万+优质牛源' },
        { name: '海量精准客商资源' },
        { name: '无纸化免疫防疫服务' },
        { name: '数智饲草管理服务' },
        { name: '数智养殖管理服务' },
        { name: '供应链金融保险服务' },
        { name: '发酵全混合日粮交易服务' }
      ],
      active: 0,
      userAgent: '', //机型
      androidUrl:
        'https://file.caoduyun.com/__UNI__497072B__20240726092652.apk',
      iosUrl: 'https://apps.apple.com/ky/app/id1601388492'
    }
  },
  created() {
    if (this.isMobile()) {
      this.active = 2
      console.log('h5')
    } else {
      this.active = 1
      console.log('web')
    }
    this.appSource()
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    appSource() {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        // return "ios";
        this.userAgent = 'ios'
      } else {
        // return "andriod";
        this.userAgent = 'andriod'
      }
    },
    navigateHref() {
      const aTag = this.$el.querySelector('a')
      if (aTag && aTag.href) {
        window.location.href = aTag.href
      }
    }
  }
}
</script>

<style lang="scss">
.w100m {
  width: 100%;
}
#download {
  width: 100%;
  font-size: 14px;
  .header {
    width: 100%;
    background: #f5f5f5;
    .div1 {
      display: flex;
      align-items: center;
      padding: 20px 15%;
      p {
        font-size: 22px;
        margin-left: 30px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #666666;
      }
    }
    .div2 {
      width: 100%;
      display: flex;
      padding: 30px 0;
      align-items: center;
      background-image: url('./image/headerbg.png');
      background-size: 100% 100%;
      justify-content: center;
      .div3 {
        margin-left: 122px;
        p:nth-of-type(1) {
          font-size: 70px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #ffffff;
          line-height: 90px;
        }
        p:nth-of-type(2) {
          font-size: 30px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #ffffff;
          line-height: 90px;
        }
        .div4 {
          display: flex;
          align-items: center;
          margin-top: 50px;
          .div5 {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-right: 50px;
            div {
              width: 120px;
              height: 120px;
              border-radius: 3px;
              padding: 5px;
              background: #fff;
              img {
                width: 100%;
              }
            }
            p {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ffffff;
              line-height: 62px;
              margin: 0;
            }
          }
        }
      }
    }
  }
  .main {
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 0;
    .main1 {
      width: 70%;
      padding: 10px 40px 100px 40px;
      display: flex;
      justify-content: space-between;
      background-image: url('./image/bg.png');
      background-size: 100% 100%;
      .main1-div {
        .title {
          font-size: 28px;
          font-weight: 700;
          color: #333;
        }
        .active {
          font-size: 24px;
          font-weight: 500;
          color: #333;
          margin-bottom: 10px;
        }
        width: 45%;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 62px;
      }
      .main2-div {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        .content {
          display: flex;
          flex-wrap: wrap;
          width: 85%;
          padding-right: 20px;
          margin-top: 50px;
          font-size: 18px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #000d05;
          line-height: 72px;
          div {
            width: 50%;
            display: flex;
            align-items: center;
            img {
              margin-right: 14px;
            }
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 16px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #fefeff;
    line-height: 36px;
    justify-content: space-between;
    background-image: url('./image/footer.png');
    padding: 40px 0 20px 0;
    div {
      display: flex;
      align-items: center;
      span {
        width: 1px;
        height: 15px;
        background: #fff;
        margin: 0 15px;
      }
    }
  }
}
#download2 {
  width: 100%;
  font-size: 14px;
  position: relative;
  .headimg {
    position: relative;
    .div1 {
      width: 100%;
      position: absolute;
      bottom: -80px;
      left: 0;
      //   border-radius: 200px 200px 0 0;
      height: 60px;
      //   position: relative;
      background: #fff;
      img {
        z-index: 10;
      }
    }
    .div1:after {
      width: 100%;
      height: 60px;
      position: absolute;
      left: 0;
      top: -50px;
      content: '';
      border-radius: 50% 50% 0 0;
      background: linear-gradient(#fff, #fff);
    }
  }
  .content {
    position: absolute;
    top: 100px;
    left: 0;
    width: 100%;
    height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    .title1 {
      font-size: 25px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: #333333;
      margin: 6px 0 5px 0;
    }
    .title2 {
      font-size: 12px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #666666;
    }
    .div2 {
      width: 86%;
      background: #ffffff;
      padding: 20px;
      border: 5px solid #c5e0d0;
      margin-top: 30px;
      position: relative;
      img {
        position: absolute;
        right: -7%;
        width: 50%;
        bottom: 30px;
      }
      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 28px;
        margin-bottom: 10px;
        .active {
          font-size: 14px;
          font-weight: 500;
          color: #333;
        }
      }
      .width {
        width: 50%;
      }
    }
    .div3 {
      width: 100%;
      height: 500px;
      margin-top: 20px;
      background-image: url('./image/bg2.png');
      background-size: 100% 100%;
      padding: 50px 0 150px 0;
      display: flex;
      justify-content: center;
      .conts {
        width: 80%;
        display: flex;
        flex-wrap: wrap;
        font-size: 12px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #000d05;
        div {
          width: 50%;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          img {
            width: 16px;
            margin-right: 7px;
          }
        }
      }
    }
    .btn {
      width: 100%;
      padding: 35px;
      div {
        width: 100%;
        padding: 9px 0;
        background: linear-gradient(90deg, #0b9e3c, #50bf34);
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-family: Arial;
        font-weight: 400;
        color: #ffffff;
        img {
          width: 17px;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>